var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNative2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2675.57 1538.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-16, .cls-17 {\n        mix-blend-mode: soft-light;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-17 {\n        opacity: .8;\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-27, .cls-28, .cls-29, .cls-30 {\n        mix-blend-mode: multiply;\n        opacity: .3;\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-32 {\n        fill: #f4f7fa;\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5220.36,
    y1: 5193.06,
    x2: 5301.14,
    y2: 5193.06,
    gradientTransform: "translate(7043.48 3942.05) rotate(-115.59) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5975.98,
    y1: 4738.18,
    x2: 6011.42,
    y2: 4664.82,
    gradientTransform: "translate(7223.58 4120.97) rotate(-120.97) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3152.4,
    y1: 1167,
    x2: -3430.89,
    y2: 1104.68,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3305.82,
    y1: 448.64,
    x2: -3235.67,
    y2: 372.94,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 4610.98,
    y1: 1399.76,
    x2: 4691.76,
    y2: 1399.76,
    gradientTransform: "translate(4893.99 -16.06) rotate(178.34) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 5014.53,
    y1: 1019.55,
    x2: 5049.98,
    y2: 946.19,
    gradientTransform: "translate(5131.03 -108.64) rotate(172.96) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -3723.66,
    y1: 902.02,
    x2: -3952.57,
    y2: 385.98,
    gradientTransform: "translate(4032.14 27.5) rotate(-7.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3610.26,
    y1: 750.15,
    x2: -3344.95,
    y2: 463.89,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3384.72,
    y1: 494.97,
    x2: -3281.86,
    y2: 494.97,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1339.8,
    y1: 2934.75,
    x2: -1368.1,
    y2: 2894.56,
    gradientTransform: "translate(3607.39 -158.4) rotate(-76.76) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1394.53,
    y1: 3008.16,
    x2: -1327.15,
    y2: 2871.29,
    gradientTransform: "translate(3607.39 -158.4) rotate(-76.76) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1432.68,
    y1: 2917.93,
    x2: -1285.72,
    y2: 2917.93,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3267.23,
    y1: 440.52,
    x2: -3190.05,
    y2: 538.35,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -3592.68,
    y1: 766.45,
    x2: -3327.36,
    y2: 480.19,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2706.37,
    y1: 1666.6,
    x2: -2697.05,
    y2: 1418.29,
    gradientTransform: "translate(3383.39 -112.79) rotate(23.5)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 3141.12,
    y1: -166.39,
    x2: 3073.64,
    y2: -337.77,
    gradientTransform: "translate(3396.97 396.15) rotate(179.15) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -2758.09,
    y1: -474.32,
    x2: -2761.2,
    y2: -224.33,
    gradientTransform: "translate(3097.45 415.13) rotate(-4.36)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 3120.51,
    y1: -158.19,
    x2: 3052.96,
    y2: -329.74,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -3571.39,
    y1: 601.24,
    x2: -3532.99,
    y2: 273.08,
    gradientTransform: "translate(3736.17)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1381.15,
    y1: 1131,
    x2: 1732.25,
    y2: 1131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1071.13,
    y1: 1042.85,
    x2: 1630.83,
    y2: 1042.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 992.51,
    y1: 1336.15,
    x2: 1553.97,
    y2: 1336.15,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 3815.07,
    y1: 187.17,
    x2: 2323.28,
    y2: 821.74,
    gradientTransform: "translate(0 -2.39) rotate(1.25) skewX(1.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2238.97,
    y1: 978.67,
    x2: 2699.32,
    y2: 1736.53,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1793.03,
    y1: 304.34,
    x2: 2053.2,
    y2: 738.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac79ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -3575.25,
    y1: -17.29,
    x2: -2885.73,
    y2: 451.06,
    gradientTransform: "translate(5641.08)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2773.09,
    y1: 213.05,
    x2: 2790.88,
    y2: 498.96,
    gradientTransform: "translate(4772.07) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -3888.33,
    y1: 1025.53,
    x2: -3795.47,
    y2: 1025.53,
    gradientTransform: "translate(5641.08)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -3844.54,
    y1: 1062.13,
    x2: -3706,
    y2: 646.51,
    gradientTransform: "translate(5641.08)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -3873.55,
    y1: 855.03,
    x2: -3816.76,
    y2: 855.03,
    gradientTransform: "translate(5641.08)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -3906.47,
    y1: 1010.97,
    x2: -3813.73,
    y2: 732.76,
    gradientTransform: "translate(5641.08)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -3792.2,
    y1: 542.26,
    x2: -3723.03,
    y2: 942.14,
    gradientTransform: "translate(5641.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab316d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792d3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -3694.52,
    y1: 1016.17,
    x2: -3596.17,
    y2: 704.92,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -3694.51,
    y1: 1016.18,
    x2: -3596.16,
    y2: 704.92,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -3556.12,
    y1: 501.9,
    x2: -3487.11,
    y2: 900.86,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -3655.89,
    y1: 254.21,
    x2: -3042.88,
    y2: 478.69,
    gradientTransform: "translate(5641.08)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 4423.5,
    y1: -379.32,
    x2: 4430.54,
    y2: -567.03,
    gradientTransform: "translate(6615.18 -174.54) rotate(169.72) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 4420.05,
    y1: -541.57,
    x2: 4417.24,
    y2: -315.2,
    gradientTransform: "translate(6615.18 -174.54) rotate(169.72) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -2164.3,
    y1: 496.69,
    x2: -1896.39,
    y2: 496.69,
    gradientTransform: "translate(4131.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40447e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -2335.63,
    y1: 327.69,
    x2: -2159.98,
    y2: 501.93,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -2335.63,
    y1: 327.69,
    x2: -2159.98,
    y2: 501.94,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 2388.14,
    y1: 509.96,
    x2: 2404.54,
    y2: 773.49,
    gradientTransform: "translate(4787.79 14.37) rotate(-173.34) scale(1 -1)",
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 2637.51,
    y1: 443.86,
    x2: 2548.45,
    y2: 527.79,
    gradientTransform: "translate(4772.07) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M90,1401.74c-5.07-2.58-13.6,.31-19.17,2.21-2.49,.84-3.74,1.27-4.46,1.91-5.3,4.69-.64,16.93,5.77,36.54,10.13,30.98,11.71,40.83,17.15,41.19,5.1,.34,9.53-7.92,10.01-8.85,2.6-4.96,2.32-9.52,1.46-18.18-1.6-16.02-3.28-26.59-3.78-29.79-3.16-19.98-3.63-23.34-6.96-25.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.9,1407.35l-32.45,17.95c-2-.12-11.35-7.98-10.69-17.82l29.81-22.35,13.34,22.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M460.31,781.5c11.27,42.65,24.08,103.79,28.18,178.16,3.4,61.64,.64,129.7-6.79,166.71-37.23,185.42-330.83,282.83-365.43,293.89-7.26-9.75-14.53-19.51-21.79-29.26,36.57-27.18,215.18-164.09,216.96-316.56,.29-24.54-3.68-77.55-13.98-134.18-11.02-60.59-26.45-109.72-38.77-143.8,67.21-4.99,134.42-9.97,201.63-14.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M423.16,250.85l26.18,5.24s137.46,175.42,117.82,242.19c-19.64,66.77-117.82,15.71-117.82,15.71l-26.18-263.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M250.64,1499.87c-4.42,3.59-5.23,12.56-5.76,18.42-.24,2.62-.36,3.93-.06,4.85,2.13,6.75,15.22,7.46,35.73,9.55,32.42,3.31,42.07,5.86,44.61,1.04,2.38-4.52-3.38-11.93-4.02-12.74-3.48-4.39-7.76-5.98-16.03-8.71-15.3-5.03-25.63-7.79-28.76-8.63-19.54-5.22-22.8-6.15-25.71-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M269.92,1470.25l3.24,36.95c-.92,1.78-11.9,7.14-20.63,2.55l-8.34-36.32,25.72-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M309.47,694.93c-8.1,147.43-14.76,297.6-19.8,450.43-3.79,114.68-6.57,227.91-8.42,339.65-13.51,1.67-27.03,3.34-40.54,5.01-13.06-24.31-30.4-61.48-42.28-109.12-14.43-57.86-11.09-92.22-17.42-152.19-7.1-67.26-17.41-81.91-35.68-166.76-37.08-172.19-55.62-258.29-14.26-311.84,13.43-17.39,55.52-61,178.4-55.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M122.32,255.36c34.96-9.83,86.18-21.33,148.93-24.87,92.51-5.23,138.78-7.54,165.93,13.72,84.22,65.95,4.4,301.69,34.42,425.56,25.25,104.22,26.18,106.04,26.18,106.04,5.97,11.65,15.64,27.84,11.78,47.13-3.04,15.17-14.51,32.6-30.11,37.96-32.41,11.15-50.99-40.67-104.73-56.29-56.18-16.33-119.03,16.11-198.51,57.14-50.58,26.11-67.85,42.76-85.57,34.5-34.13-15.91-24.76-103.15-20.95-138.77,15.14-141.54,32.17-307.25,52.63-502.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M354.43,495.65c-2.45-.55-6.8-16.82,3.93-21.6,48.44-21.6,85.92,21.17,90.93,34.33l5.01,13.16s-24.06,1.88-38.97-3.13c-14.92-5.01-41.01-18.32-60.9-22.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M486.77,556.9l-85.22,4.3c-3.26,.16-7.16-3.88-6.36-6.63l39.81-128.82c.63-2.14,2.81-3.57,5.23-3.44l81.73,1.79c2.66,.16,4.12,5.4,3.4,7.99l-33.86,121.13c-.56,2-2.57,3.56-4.72,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M485.23,554.16l-85.69,4.02c-3.28,.15-5.55-2.2-4.74-4.95l38.28-131.05c.63-2.15,2.82-3.58,5.26-3.43l81.84,4.84c2.68,.16,4.48,2.73,3.75,5.34l-33.95,121.56c-.56,2-2.58,3.57-4.74,3.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M441.97,476.02c2.54,11.92,13.26,9.35,22,23.78,11.1,18.31,.46,34.48,10.64,41.19,3.11,2.05,8.35,3.28,17.79,.81l-2.43,8.7c-.56,2-2.58,3.57-4.74,3.67l-85.69,4.02c-3.28,.15-5.55-2.2-4.74-4.95l38.28-131.05c.63-2.15,2.82-3.58,5.26-3.43l12.29,.73c1.44,4.5,2.48,9.7,2.36,15.46-.39,19.76-14,27.13-11.02,41.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M524.28,466.4c.48-2.06-.54-4.18-2.07-4.29-6.24-.45-20.7-.63-28.68,6.28-10.37,8.99-23.78,25.38-12.49,33.66l10.55,7.73c.48,.36,1.01,.47,1.54,.3,3.75-1.17,19.52-6.11,21.24-7.34,1.57-1.12,7.58-26.36,9.91-36.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M453.27,811.15c-9.14-15.84-8.76-39.77-28.8-51.06-11.69-6.58-20.8-3.5-36.66-3.93-47.27-1.26-56.32-31-89.02-32.73-50.64-2.68-74.97,66.22-103.42,56.29-18.57-6.48-30.53-43.63-20.95-72,13.36-39.56,59.15-34.14,119.13-87.71,25.66-22.92,62.47-64.28,52.37-82.47-10.62-19.12-61,8.93-98.18-19.64-21.7-16.67-18.93-37.27-36.66-74.62-9.61-20.24-44.78-72.86-97.1-108.33-16.82,160.85-31.26,300.67-44.29,422.52-3.81,35.62-13.18,122.85,20.95,138.77,17.72,8.26,34.99-8.39,85.57-34.5,79.48-41.03,142.33-73.47,198.51-57.14,53.74,15.62,72.32,67.44,104.73,56.29,10.12-3.48,18.46-12.07,23.93-21.8-28.9-5.2-43.23-16.01-50.11-27.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.6,162.45c.06,7.03,7.56,39.21-16.03,56.29-23.8,17.24-45.91,16.98-54.83,19.2-20.69,5.13-23.35,4.99-23.81,7.04-2.23,10.01,54.18,44.15,112.46,35.92,35.67-5.03,68.12-25.38,66.13-36.07-2.01-10.75-37.63-4.98-48.25-24.44-7.39-13.53,.89-32.75,10.68-48.66-9.48-17.76-36.87,8.48-46.35-9.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M351.52,150.81c8.29-11.27,8.6-30.8-1.24-43.03-8.46-10.52-21.61-11.89-29.49-12.72-22.81-2.38-51.46,7.45-61.22,28.53-5.79,12.49,7.32,38.17,9.38,42.79,2.33,5.22,6.47,6.98,10.33,10.91,5.34,5.44,13.71,14.11,27.37,28.59,1-4.33,2.54-9.7,5.01-15.52,.95-2.24,4.77-11,10.62-18.29,11.71-14.61,21.39-10.59,29.25-21.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.25,193.79s15.25,24.41,45.05,22.14c26.68-2.03,29.93-61.96,12.73-74.48-5.74-4.18-17.15-5.81-26.39-3.11-5.46,1.59-7.28,3.89-16.25,6.32-8.27,2.24-10.62,1.35-13.1,3.48-3.1,2.67-5.32,9.16,.1,26.6-5.15-5.1-11.29-7.01-15.6-4.92-.69,.34-2.51,1.6-3.52,3.5-3.66,6.88,2.69,15.55,16.97,20.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.05,144.58c1.3,.95-2.59,5.79-2.8,12.6-.43,13.2,13.11,28.9,26.75,30.09,8.07,.7,10.23-4.18,23.53-5.73,8.24-.96,15.11,.01,19.44,.91,4.35,14.43,.57,28.91-9.03,35.71-10.34,7.33-23.69,3.1-29.28,1.33-3.74-1.18-15.7-4.94-22.06-15.81-6.62-11.32-.32-18.27-7.86-25.89-3.8-3.85-8.76-5.48-13.65-12.95-1.33-2.03-2.22-3.83-2.77-5.04,6.81-7.38,15.83-16.58,17.71-15.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M194.06,295.36c-14.12-21.42-42.23-42.45-68.07-40.58-75.48,5.45-168.53,208.78-104.73,289.32,48.7,61.48,199.14,64.46,336.44-41.89v-35.35c-67.56,11.82-123.58,19.66-164.95,24.87-25.8,3.25-51.51,6.18-56.29-3.93-7.24-15.29,44.44-37.17,64.15-94.26,2.72-7.87,19.99-57.93-6.55-98.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1570.71,1456.87c-.24,.04-.49,.08-.73,.12-39.68,6.34-89.41,1.91-121.54-24.5-16.93-13.91-28.4-32.27-31.92-54-2.09-12.89-3.22-26.49-1.21-39.46,2.11-13.58,7.36-26.69,14.12-38.6,3.77-6.65,8.08-13.07,12.65-19.2,13.09-17.56,44.01-42.23,29.67-67.12-8.67-15.05-28.64-24.31-41.84-34.87-28.21-22.56-48.46-55.08-48.75-92.21-.22-29.17,18.07-58.05,38.7-77.67,83.98-79.82,22.11-217.09,141.05-206.31,118.94,10.78,144.74,129.48,100.2,240.3-14.91,37.1-33.06,75.03-43.19,113.81-7.97,30.53,3.3,51.64,28.15,69.67,13.37,9.7,32.92,16.32,44.54,27.75,25.95,25.54,46.74,61.34,40.55,98.81-6.15,37.17-37.83,64.47-71.22,78.59-28.87,12.21-58.34,19.93-89.23,24.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1556.7,1424.98c-.28,0-.56-.05-.84-.15-1.27-.46-1.92-1.87-1.46-3.13,.5-1.38,49.79-138.98,6.64-249.25-43.86-112.07,5.2-232.05,5.7-233.25,.52-1.24,1.95-1.83,3.2-1.31,1.25,.52,1.83,1.95,1.31,3.2-.49,1.18-48.78,119.39-5.66,229.59,43.83,112.02-6.09,251.31-6.6,252.71-.36,.99-1.3,1.61-2.3,1.61Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1595.79,1250.19c-9.96-15.76-21.35-30.59-33.24-44-40.19-45.31-68.4-93.41-86.45-151.45-14.22-45.72-13.91-97.98-22.74-145.19-6.39-34.2-17.97-67.3-30.01-99.87-25.62-69.34-64.09-149.79-128.64-191.43-29.89-19.28-74.21-21.18-107.18-7.37-42.71,17.89-80.47,52.75-83.21,101.22-3.77,66.66,54.46,141.38,6.3,202.67-73.73,93.86-39.26,198.13,62.1,249.16,33.03,16.63,71.74,32.05,99.34,57.59,27.68,25.62,11.18,69.33,8.11,101.78-2.89,30.45-6.07,65.83,13.34,91.87,32.74,43.93,111.8,63.07,163.19,67.41,49.73,4.2,106.23-1.29,141.06-41.11,52.48-59.99,35.35-132.22-1.98-191.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1514.86,1441.27c-.99,0-1.92-.6-2.29-1.58-1.61-4.27-162.41-428.61-254.16-599.61-.64-1.19-.19-2.67,1-3.31,1.19-.64,2.67-.19,3.31,1,91.9,171.28,252.81,595.93,254.43,600.2,.48,1.26-.16,2.67-1.42,3.15-.28,.11-.58,.16-.86,.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1445.36,1501.29c10.7-1.51,21.37-3.27,31.99-4.98,29.69-4.76,66.47-14.01,75.8-47.14,2.66-9.44-1.92-26.28-3.02-36.08-1.12-9.99-2.55-19.97-4.87-29.76-3.21-13.53-8.36-26.24-15.03-38.41-11.56-21.09-24.78-36.96-49.39-41.74-17.94-3.48-37.82-4.29-56.06-3.7-99.41,3.26-111.64-32.59-166.23-109.19-54.6-76.6-413.95,47.26-197.2,183.34,0,0,32.59,21.19,151.56,7.33,21.76-2.53,49.28-4.22,67.73,9.86,32.54,24.82-.18,77.43,32.67,98.07,19.16,12.04,49.94,15.58,71.95,16.42,20.11,.77,40.15-1.21,60.08-4.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1511.71,1460.29c-.76,0-1.5-.35-1.98-1.01-.63-.86-63.56-86.42-152.84-106.61-34.92-7.9-65.11-25.58-94.3-42.67-49.22-28.83-95.72-56.05-164.34-42.06-1.33,.27-2.61-.58-2.88-1.91-.27-1.32,.58-2.61,1.91-2.88,70.45-14.37,119.94,14.61,167.79,42.63,28.87,16.91,58.72,34.39,92.91,42.12,91.11,20.61,155.08,107.63,155.72,108.51,.79,1.09,.55,2.62-.54,3.41-.43,.31-.94,.47-1.43,.47Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "2039.98 1538.71 1482.82 1503.15 1482.82 655.16 2039.98 671.18 2039.98 1538.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "2527.34 1497.22 2039.98 1538.71 2039.98 671.18 2527.34 661.01 2527.34 1497.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1482.82 655.16 2012.74 632.19 2527.34 661.01 2034.18 679.27 1482.82 655.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2103.72,231.84c-12.97-8.41-1.15-32.87-.45-85.42,.86-64.39-16.25-76.39-2.51-101.66,16.8-30.89,59.08-43.68,87.1-44.28,6.18-.13,7.62-3.51,59.39,9.9,93.26,24.15,116.6-1.74,158.37,24.12,40.35,24.99,22.68,52.35,61.86,81.66,63.51,47.5,130.3-3.85,175.69,35.88,42.93,37.58,43.92,133.33-1.24,185.59-51.19,59.24-143.51,41.44-205.38,29.69-13.02-2.47-78.77-16.28-147.23-66.81-37.87-27.95-63.88-57.81-80.42-79.8-3.88-4.37-9.94-9.66-17.94-10.52-9.6-1.03-17.32,4.85-21.03,7.42-19.52,13.52-53.45,22.49-66.19,14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M2147.69,156.98c-16.68-15.19-76.2,14.09-115.64,52.96-46.34,45.66-42.78,82.69-83.22,139.42-20.1,28.2-54.57,66.17-115.64,99.43,4.32,10.81,8.65,21.62,12.97,32.42,29.53,1.78,87.5,.73,141.58-34.58,37.57-24.53,56.9-57.04,94.03-121.05,37.26-64.24,86.77-149.6,65.93-168.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1771.78,1025.51l46.46-27.92h20.97s7.14,26.59,6.33,27.92c-9.34,15.31-52.84,26.95-79.98,27.92-4.51,.16-10.8,.18-12.42-3.08-2.75-5.53,9.54-17.13,18.64-24.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1819.07,967.12c2.99,17.28-.79,26.29-4.86,31.34-2.87,3.55-5.41,4.56-22.42,19.27-5.63,4.86-8.49,7.47-7.84,8.83,.74,1.56,5.71,.71,16.43-1.86,23.36-5.62,35.1-8.54,37.97-14.16,2.59-5.09,.3-7.39,.45-21.26,.1-9.13,1.96-16.48,3.42-21.08-7.71-.36-15.43-.72-23.14-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1785.48,830.15s-20.99,25.05-17.58,52.51c3.42,27.46,40.18-12.69,45.3-26.25,5.13-13.57,11.11-32.9,11.11-32.9,0,0-25.78-16.04-38.84,6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1793.49,790.96s5.69,29.18-5.17,44.58c-5.41,7.67-12.71,14.18-10.56,20.42,1.44,4.18,6.9,7.19,11.52,6.72,8.85-.91,13.76-14.48,17.23-24.06,5.11-14.14,7.96-44.41,7.96-44.41l-20.99-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1810.22,815.56c-6.46-2.35-12.91-4.7-19.37-7.05-10.07-23-22.36-60.78-18.26-106.71,10.56-118.1,119.79-180.68,131.92-187.38,29.76,14.93,59.9,36,60.99,62.55,1.37,33.33-44.04,50.96-86.73,99.7-25.62,29.26-53,72.85-68.56,138.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1817.18,980.63c-21.33-83.32-15.88-151.31-9.73-190.48,9.3-59.2,28.22-179.62,108.62-224.53,17.56-9.81,42.66-18.59,73.25-45.85,25.55-22.77,41.78-46.71,51.58-63.58,107.52-31.54,206.7-18.76,250.46,38.91,5.06,6.66,17.72,21.12,20.17,42.43,5.53,48.09-41.72,105.98-94.74,118.06-67.38,15.36-106.47-53.82-166.17-30.8-16.7,6.44-30.86,22.39-59.17,54.31-36.02,40.6-56.27,78.06-63.93,93.05-22.81,44.63-40.11,77.58-42.63,120.29-.59,9.95-.94,30.05-12.59,51.72-8.94,16.64-21.07,27.73-30.09,34.59-8.34,.63-16.69,1.26-25.03,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2311.52,537.53c-2.45-21.31-15.11-35.76-20.17-42.43-43.76-57.67-142.94-70.45-250.46-38.91-9.8,16.87-26.03,40.81-51.58,63.58-30.59,27.26-55.69,36.04-73.25,45.85-49.1,27.42-75.24,82.99-90.3,135.6,22.34-34.63,41.45-43.84,56.25-44,21.18-.24,30.64,17.87,55.93,15.4,27.03-2.64,33.21-24.99,55.12-27.56,6.56-.77,14.63,.24,24.32,5.4,12.93-13.54,22.57-21.56,33.23-25.67,59.7-23.02,98.79,46.17,166.17,30.8,53.02-12.09,100.26-69.98,94.74-118.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1872.89,602.89c12.17-.65,30.91-1.02,53.52,1.21,107.29,10.6,136.86,63.67,225.53,76.62,20.98,3.06,114.37,16.7,154.82-37.29,29.04-38.76,24.65-105.55-7.12-131.82-13.44-11.12-26.75-10.81-112.85-10.03-32.42,.29-64.85,.4-97.27,.81-137.24,1.75-163.49-7.76-188.46,14.94-11.65,10.59-28.68,33.33-28.18,85.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2162.62,162.55s160.15-46.71,176.76,70.54c15.92,112.38-65.65,163.94-28.53,277.77,4.3,13.19-304.86-47.24-304.86-47.24,41.27-51.49,50.86-93.96,51.84-123.49,1.08-32.38-8.25-47.09,0-85.37,0,0,9.21-42.71,42.42-79.38,4.77-5.26,10.45-10.75,62.36-12.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2265.49,486.83c-.15,0-.32-.02-.47-.06-1.5-.4-151.08-40.2-239.42-45.16-1.01-.06-1.79-.93-1.73-1.94,.06-1.01,.8-1.78,1.94-1.73,88.72,4.97,238.66,44.87,240.16,45.28,.98,.26,1.57,1.27,1.3,2.25-.22,.82-.97,1.36-1.78,1.36Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2197.4,92.28c-1.47,6.85-8.94,43.63,6.11,53.1,3.26,2.05,9.53,3.23,22.07,5.58,8.21,1.54,15.09,2.48,19.95,3.06-.7,6.17-2.78,16.21-9.9,25.34-19.95,25.6-59.96,18.97-65.66,17.93-20.12-3.66-39.92-9.88-44.71-13.68-7.28-5.79-13.01-10.13-16.39-14.54,7.79-3.76,23.51-13.69,34.06-16.94,7.89-2.43,15.29-4.16,22.02-5.4,1.11-7.1,2.21-14.21,3.32-21.32,9.71-11.05,19.42-22.09,29.13-33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2197.84,111.56s-2.53,25.1-26.94,29.53c-21.85,3.96-38.3-48.84-27.12-62.5,3.73-4.56,12.94-8.89,20.92-8.66,5.61,.16,24.58,7.38,27.22,26.36,3.78-3.98,8.48-5.12,10.8-3.46,2.94,2.11,1.37,8.26,1.01,9.65-1.24,4.82-4.39,7.81-5.91,9.07Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1973.35,476.78l245.12,11.93c3.37,.17,6.45,1.97,8.24,4.84l6.78,10.89c3.38,5.42-.68,12.41-7.06,12.16l-259.64-9.89,6.56-29.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1718.41,340.28l253.23,4.91c7.49,.15,14.35,4.23,18.06,10.74l87.69,154.28-267.44-10.65c-7.34-.29-14.04-4.27-17.81-10.57l-81.25-135.73c-3.46-5.78,.79-13.11,7.52-12.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1989.7,355.93c-3.7-6.52-10.56-10.6-18.06-10.74l-5.55-.11c-.83,8.17-3.34,15.65-8.34,21.69-15.61,18.85-41.56,7.22-60.89,27.17-21.24,21.91-1.62,47.99-20.61,68.39-19.99,21.46-52.31,3.99-89.47,17.72l5.35,8.94c3.77,6.3,10.47,10.28,17.81,10.57l267.44,10.65-87.69-154.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M2198.49,468.59c-3.19-8.43-6.38-16.85-9.57-25.28,35.26-9.67,84.03-23.95,134.05-41.82,7.83-2.8,17.14-6.27,20.19-14.51,8.55-23.12-45.82-47.09-66.96-97.58-19.55-46.7-8.79-111.5,13.9-119.16,47.21-15.93,214.63,192.47,154.84,280.31-33.8,49.66-138.01,57.57-246.44,18.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2188.92,443.31c-22.14-11.76-48.63,.29-50.34,1.1-4.86,2.3-11.94,6.39-19.1,13.69-.81,1.1-10.41,14.41-6.91,18.67,2.8,3.42,13.66,.58,26.71-7.53,5.47-.77,13.61-1.47,23.37-.57,17.92,1.65,26.12,7.31,32.63,2.43,4.76-3.58,6.39-11.14,4.67-16.76-1.84-6.04-7.29-9.04-11.03-11.03Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNative2);
export default __webpack_public_path__ + "static/media/native2.36b38973ca8f7cd8ec606e267d1a3fa7.svg";
export { ForwardRef as ReactComponent };